/* eslint-disable no-console */

import { register } from 'register-service-worker';
const appConfig = require('@/.generic/appConfig.json');

// function getLogInfo () {
//   let ret = { version: appConfig.buildTime, processEnv: process.env.NODE_ENV };
//   return ret;
// }

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB', appConfig.buildTime
      );
    },
    registered () {
      console.log('Service worker has been registered.', appConfig.buildTime);
    },
    cached () {
      console.log('Content has been cached for offline use.', appConfig.buildTime);
    },
    updatefound () {
      console.log('New content is downloading.', appConfig.buildTime);
    },
    updated () {
      console.log('New content is available; please refresh.', appConfig.buildTime);
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.', appConfig.buildTime);
    },
    error (error) {
      console.error('Error during service worker registration:', error, appConfig.buildTime);
    }
  });
}
